import { Pipe, PipeTransform } from '@angular/core';

import { diffColor } from '../constants/constants';

@Pipe({
  name: 'diffColor',
  standalone: true,
})
export class DiffColorPipe implements PipeTransform {
  transform(quadrant, starsEgp: any, starsVerification: any) {
    return diffColor(quadrant, starsEgp, starsVerification);
  }
}
